import * as React from 'react';

export interface IOption {
    value: any;
    optionText: string;
    label?: string;
}

export interface ISelect {
    label?: string;
    value?: any;
    originalValue?: any;
    id?: any;
    options: IOption[];
    name?: string;
    disabled?: boolean;
    className?: string;
    onChange?(value: React.ChangeEvent<HTMLSelectElement>): void;
}

export class Select extends React.Component<ISelect> {
    public render() {
        const options = this.createOptions();
        return(
            <>
                { this.props.label && <label className="filter-label">{this.props.label}</label>}
                <select
                    name={this.props.name}
                    value={this.props.value}
                    id={this.props.id? this.props.id:'filter-dropdown'}
                    className="form-control"
                    onChange={this.props.onChange}
                    disabled={!!this.props.disabled}
                >
                    {options}
                </select>
            </>
        );
    };

    private createOptions = () => this.props.options.map((option: IOption, index: number) => (
        <option
            key={index}
            defaultValue={option.value}
            value={option.value}
        >
            {option.optionText}
        </option>
    ));
}
